import React from 'react';
import { OnCallUser } from '../Model/MonitoringModel';
import { CardWrapper } from '../../Common/CommonComponents';
import { CircularProgress, Divider, Typography, Box } from '@mui/material';
import { AccountCircle, Email, Phone } from '@mui/icons-material';
import { getNumberOfWeek } from '../../../../Helpers/UtilityMethods';

interface Props {
  onCallUserOfTheWeek: OnCallUser;
  loadingOnCallUser: boolean;
}

const OnCallOfTheWeek: React.FC<Props> = ({
  onCallUserOfTheWeek,
  loadingOnCallUser,
}) => {
  return (
    <CardWrapper>
      {loadingOnCallUser ? (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          minHeight={150}
        >
          <CircularProgress />
        </Box>
      ) : (
        <Box sx={{ width: '100%', maxWidth: { xs: '100%' } }}>
          <Typography variant="h6" sx={{ mb: 2 }}>
            On call for the week: Week {getNumberOfWeek()}
          </Typography>
          <Divider sx={{ mb: 3 }} />

          {/* User Name */}
          <Box
            display="flex"
            alignItems="center"
            gap={1}
            flexWrap="wrap"
            sx={{ mb: 1 }}
          >
            <AccountCircle fontSize="medium" color="primary" />
            <Typography
              variant="h6"
              sx={{
                fontWeight: 500,
                flex: 1,
                minWidth: 0,
                wordBreak: 'break-word',
              }}
            >
              {onCallUserOfTheWeek.Name}
            </Typography>
          </Box>

          {/* Email */}
          <Box
            display="flex"
            alignItems="center"
            gap={1}
            flexWrap="wrap"
            sx={{ mb: 1 }}
          >
            <Email fontSize="small" color="action" />
            <Typography
              variant="body2"
              sx={{
                color: 'text.secondary',
                flex: 1,
                minWidth: 0,
                wordBreak: 'break-word',
              }}
            >
              {onCallUserOfTheWeek.EmailAddress}
            </Typography>
          </Box>

          {/* Phone */}
          <Box display="flex" alignItems="center" gap={1} flexWrap="wrap">
            <Phone fontSize="small" color="success" />
            <Typography
              variant="body1"
              sx={{ fontWeight: 500, flex: 1, minWidth: 0 }}
            >
              {onCallUserOfTheWeek.PhoneNumber}
            </Typography>
          </Box>
        </Box>
      )}
    </CardWrapper>
  );
};

export default OnCallOfTheWeek;
